function Home() {
  return (
    <div className="homePageDiv">
      <h1>Welcome to our website!</h1>
      <p>
        Here, you&#39;ll find two exciting tabs to explore:
        a calculator and a collection of famous quotes.
      </p>
      <p>
        In the calculator tab, you can perform various
        calculations with ease. Whether you need to add,
        subtract, multiply, or divide, our calculator has
        got you covered. Simply input the numbers and operators,
        and let our calculator do the rest. It&#39;s a handy tool for
        all your mathematical needs.
      </p>
      <p>
        Switching over to the quotes tab, get ready to be inspired
        by a diverse collection of famous quotes. Each time you visit
        this page, our website fetches new quotes from an API, ensuring
        a fresh and motivational experience. From renowned authors,
        thinkers, and leaders, these quotes will uplift your spirits
        and provide you with valuable insights.
      </p>
    </div>
  );
}

export default Home;
